// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCGdZQpxZSi9icHUY7OgvrlDmmVpk98aSk",
    authDomain: "togethra.firebaseapp.com",
    projectId: "togethra",
    storageBucket: "togethra.firebasestorage.app",
    messagingSenderId: "64940730822",
    appId: "1:64940730822:web:c88e436bb77173c4902ac7",
    measurementId: "G-6LYY9JHBKX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent };